import script from "./AppNavAffiliateButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AppNavAffiliateButton.vue?vue&type=script&setup=true&lang=js"

import "./AppNavAffiliateButton.vue?vue&type=style&index=0&id=272b97ca&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-272b97ca"]])

export default __exports__